module.exports = __webpack_public_path__ + "img/product-mmm2.c112b58d.jpg";